/* Flat Banner Row — mobile slider dots.

   The sliding itself is CSS scroll-snap, so this script is purely the position
   indicator: if it never runs, the rail still swipes one banner at a time and
   the only thing missing is the dots. That is why the markup ships an empty
   <div> and the dots are built here rather than rendered in Liquid - a dot per
   banner is only correct once we know the rail is actually scrollable. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 767px)';

  function setup(section) {
    var rail = section.querySelector('[data-fbr-rail]');
    var dotsBox = section.querySelector('[data-fbr-dots]');
    if (!rail || !dotsBox) return;

    var slides = Array.prototype.slice.call(rail.querySelectorAll('.flat-banner-row__cell'));
    if (slides.length < 2) return;

    var dots = [];
    var current = -1;
    var observer = null;

    function select(index) {
      if (index === current) return;
      current = index;
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function build() {
      if (dots.length) return;
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'flat-banner-row__dot';
        dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        dot.setAttribute('aria-label', 'Banner ' + (i + 1) + ' of ' + slides.length);
        dot.addEventListener('click', function () {
          // scrollIntoView would also scroll the page vertically to reach the
          // rail; moving the rail's own scrollLeft keeps the jump horizontal.
          rail.scrollTo({ left: slide.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
        });
        dotsBox.appendChild(dot);
        dots.push(dot);
      });
      current = 0;

      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) select(slides.indexOf(entry.target));
          });
        },
        // Against the rail, not the viewport: a slide counts as "the one being
        // looked at" once most of it is inside the rail's own box.
        { root: rail, threshold: 0.6 }
      );
      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }

    function teardown() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      dotsBox.textContent = '';
      dots = [];
      current = -1;
    }

    function sync(matches) {
      if (matches) build();
      else teardown();
    }

    var mq = window.matchMedia(MOBILE);
    sync(mq.matches);

    if (mq.addEventListener) {
      mq.addEventListener('change', function (e) {
        sync(e.matches);
      });
    } else if (mq.addListener) {
      mq.addListener(function (e) {
        sync(e.matches);
      });
    }
  }

  function init(root) {
    (root || document)
      .querySelectorAll('.flat-banner-row--slider-mobile')
      .forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor rebuilds a section's DOM on every settings change, which drops
  // the observer and the dots with it.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
